import React, { useEffect } from 'react';
import { useStaticQuery, graphql } from "gatsby";

// Hooks //
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

// Styles //
import "./shareModal.scss";

// Social Data //
import {SocialMedia} from "../../../data/share.data.js"

interface ShareModalProps {
    onClose: (e) => void;
    isOpen: boolean;
    link?: string;
}

const ShareModal = (props: ShareModalProps ) => {
    const { document } = useBrowserMode();

    useEffect(() => {
        document.body.style.overflow = props.isOpen ? "hidden" : "initial";
    }, [props.isOpen]);


    const icons = useStaticQuery(graphql`
        query SHAREICONS {
            iconFacebook: allContentfulAsset(
                filter: { title: { eq: "share-icon-facebook" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconWhatsapp: allContentfulAsset(
                filter: { title: { eq: "share-icon-whatsapp" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconLinkedin: allContentfulAsset(
                filter: { title: { eq: "share-icon-linkedin" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const iconFacebook: string = icons.iconFacebook.nodes[0].file.url;
    const iconWhatsapp: string = icons.iconWhatsapp.nodes[0].file.url;
    const iconLinkedin: string = icons.iconLinkedin.nodes[0].file.url;

    return (
        <div className="overlay-modal"
            style={{
                visibility: props.isOpen ? "visible" : "hidden",
                opacity: props.isOpen ? "1" : "0"
            }}>
            <div className="m-share-modal">
                <button className="m-share-modal__close icon-close" onClick={() => props.onClose(false)}></button>
                <span className="m-share-modal__title">Compartir contenido</span>
                <p className="m-share-modal__subtitle">Te brindamos estas opciones para compartirlo</p>
                <div className="m-share-modal__social">
                    <a  className="gtmVacanteClickButtonFacebook" target='_blank' href={`${SocialMedia[0].link}${props.link}`} rel="noreferrer">
                        <img src={iconFacebook} alt="Compartir Facebook" />
                    </a>
                    <a className="gtmVacanteClickButtonWhatsapp" target='_blank' href={`${SocialMedia[1].link}${props.link}`} rel="noreferrer">
                        <img src={iconWhatsapp} alt="Compartir Whatsapp" />
                    </a>
                    <a className="gtmVacanteClickButtonLinkedin" target='_blank' href={`${SocialMedia[2].link}${props.link}`} rel="noreferrer">
                        <img src={iconLinkedin} alt="Compartir Linkedin" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default ShareModal
